import React, {useState} from "react";
import "./RxTx.css";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Signal from "./Signal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";


function RxTx({bond}) {

    const [isRx, setIsRx] = useState(false);
    const [frequency, setFrequency] = useState(433000);
    const [modulation, setModulation] = useState("OOK");
    const [rxSignal, setRxSignal] = useState(null);

    const [signalsStorage, setSignalsStorage] = useState(JSON.parse(localStorage.getItem(`signals`) || "{}"));

    function reloadSignalStorage() {
        setSignalsStorage(JSON.parse(localStorage.getItem(`signals`) || "{}"));
        setRxSignal(null);
    }

    async function rx() {
        setIsRx(true);
        const signalResponse = await bond.scan(parseInt(frequency), modulation);
        setIsRx(false);
        if (signalResponse && signalResponse.data) {
            setRxSignal(signalResponse);
        }
    }


    return (<>
        <Row className={"rxtxRow"}>
            <InputGroup>
                <InputGroup.Text>Frequency (kHz)</InputGroup.Text>
                <Form.Select
                    value={frequency}
                    onChange={(e) => setFrequency(e.target.value)}
                >
                    <option>-- Presets --</option>
                    <option value={0}>Frequency Search (auto)</option>
                    <option value={38}>38 (IR)</option>
                    <option value={300000}>300.000 kHz (min)</option>
                    <option value={304900}>304.900 kHz</option>
                    <option value={315000}>315.000 kHz</option>
                    <option value={433000}>433.000 kHz</option>
                    <option value={433920}>433.920 kHz</option>
                    <option value={434150}>434.150 kHz</option>
                    <option value={450000}>450.000 kHz (max)</option>
                </Form.Select>
                <Form.Control
                    type="number"
                    min={300000}
                    max={450000}
                    value={frequency}
                    className={"rxFrequencyInput"}
                    onChange={(e) => setFrequency(e.target.value)}
                />
                <InputGroup.Text className={"bg-dark"}>kHz</InputGroup.Text>
                <Button variant="primary"
                        onClick={rx}
                        className={"rxScanButton"}
                        disabled={isRx ? "disabled" : ""}>{isRx &&
                    <FontAwesomeIcon icon={faSpinner} className={"fa-spin"}/>} Scan
                </Button>

            </InputGroup>
            {rxSignal && <Signal bond={bond} signal={rxSignal} open={true} onUpdateStorage={reloadSignalStorage}/>}

        </Row>
        <hr/>
        {signalsStorage && <Row className={"pt-1"}>
            <h3>Signals Local Storage</h3>
            <Row>
                {Object.keys(signalsStorage).map((signalId) => <Signal key={signalId} bond={bond}
                                                                       signal={signalsStorage[signalId]}
                                                                       onUpdateStorage={reloadSignalStorage}/>)}
            </Row>
        </Row>}</>);
}

export default RxTx;
